import TenCheckbox from '../checkbox';
import tableCellMixin from './table-cell-mixin';

// const TYPES = ['selector', 'expand'];
const TYPES = {
  selector: 'renderSelector',
  expand: 'renderExpand',
  sortable: 'renderSortable',
};
const ORDERS = ['asc', 'desc', 'default'];
const NOOP = () => {};

export default {
  name: 'table-head-cell',
  inject: ['table'],
  mixins: [tableCellMixin],
  props: {
    column: {
      type: Object,
      default: () => {},
    },
    row: {
      type: Object,
      default: () => {},
    },
    index: Number,
    rowspan: Number,
    colspan: Number,
  },
  data() {
    return {
      html: '',
    };
  },
  computed: {
    _selectableRows() {
      let selectableRows;
      if (typeof this.column.selectable === 'function') {
        selectableRows = this.table.data.filter((row, index) => this.column.selectable(index, row));
      } else {
        selectableRows = this.table.data;
      }
      return selectableRows;
    },
    _selectorChecked() {
      const selectableRows = this._selectableRows;
      return (
        selectableRows.length > 0
        && selectableRows.every(row => this.table.selectedRowKeys.indexOf(this.table.getRowKey(row)) > -1)
      );
    },
    className() {
      const align =        this.column.headerAlign || this.column.titleAlign || this.column.align;
      return [
        'ten-table__table-cell',
        this.column.className,
        {
          [`ten-table__table-cell--align-${align}`]: align,
          'ten-table__table-cell--invisible': this.invisible,
          [`ten-table__table-cell--sortable-${this.column.order}`]: this.column
            .sortable,
          sortable: this.column.sortable,
        },
      ];
    },
  },
  render(h) {
    const { title, type, sortable } = this.column;

    // 对 title 的 jsx 函数进行额外的处理
    let content;
    if (!title) {
      content = '';
    } else {
      content = typeof title === 'function' ? title(h) : title;
    }

    if (TYPES[type]) content = this[TYPES[type]](h)(content);
    // 对 sortable 类型的，暂时需要额外处理
    if (sortable) content = this.renderSortable(h)(content);

    if (this.invisible) {
      return (
        <th
          class={this.className}
          rowspan={this.rowspan}
          colspan={this.colspan}
        ></th>
      );
    }
    return (
      <th
        class={this.className}
        rowspan={this.rowspan}
        colspan={this.colspan}
        onClick={sortable ? this.onHeadClick : NOOP}
      >
        {content}
      </th>
    );
  },
  methods: {
    renderSortable(h) { // eslint-disable-line
      return content => (
          <div style={{ display: 'inline-flex' }}>
            {content}
            <span class="sorter-wrapper">
              <i class="sorter-asc"></i>
              <i class="sorter-desc"></i>
            </span>
          </div>
      );
    },
    renderSelector(h) { // eslint-disable-line
      return (content) => {
        if (this.column.selectType === 'radio') {
          return content;
        }
        const selectableRows = this._selectableRows;
        const atLeastOneSelected = selectableRows
          .some(row => this.table.selectedRowKeys.indexOf(this.table.getRowKey(row)) > -1);
        return (
          <div>
            <TenCheckbox
              onChange={this.onSelectorChange}
              checked={this._selectorChecked}
              disabled={
                this.column.disabledSelectAll || selectableRows.length === 0
              }
              indeterminate={!this._selectorChecked && atLeastOneSelected}
            ></TenCheckbox>
            {content}
          </div>
        );
      };
    },
    onSelectorChange(checked) {
      const selectableRows = this._selectableRows;
      const selectableKeys = selectableRows.map(row => this.table.getRowKey(row));
      let selectedKeys = [...this.table.selectedRowKeys];

      if (checked) {
        selectableKeys.forEach((key) => {
          if (selectedKeys.indexOf(key) === -1) {
            selectedKeys.push(key);
          }
        });
      } else {
        selectedKeys = selectedKeys.filter(key => selectableKeys.indexOf(key) === -1);
      }
      this.table.changeSelected(selectedKeys);
    },
    onHeadClick() {
      const index = ORDERS.findIndex(v => v === this.column.order);
      this.table.$emit(
        'sort-change',
        ORDERS[(index + 1) % ORDERS.length],
        this.column
      );
    },
    renderExpand() {
      return content => content;
    },
  },
};
